import { render } from "./Hamburger.vue?vue&type=template&id=43a7de52&scoped=true"
const script = {}

import "./Hamburger.vue?vue&type=style&index=0&id=43a7de52&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a7de52"]])

export default __exports__